/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvalidDataReportStatus {
    WAITING_FOR_REVIEW = 'WaitingForReview',
    ACCEPTED = 'Accepted',
    REJECTED = 'Rejected',
    IN_PROGRESS = 'InProgress',
}
